














































































































import { Component, PropSync, Prop, Vue, Watch } from "vue-property-decorator";
import { saveFile } from "@/shared/saveFile";
import DateField from "@/components/misc/DateField.vue";
import TimeField from "@/components/misc/TimeField.vue";
import { Getter } from "vuex-class";
import { CashRegisterModel } from "@/shared/models/cashRegister";
import { enumToArray } from "@/shared/commonFunctions";
import { getDateTimeOffsetString } from "@/shared/dateFormatUtils";

export enum CashiersReportExportTypeEnum {
  PDF = 1,
  Excel = 2,
}

@Component({
  components: {
    DateField,
    TimeField,
  },
})
export default class CashiersReportExportModal extends Vue {
  @PropSync("open") internalOpen?: boolean;
  @Prop() filters?: any;

  dateRange: string[] = [];
  timeFrom = "00:00";
  timeTo = "23:59";
  cashRegisterId = null as number | null;
  exportType = CashiersReportExportTypeEnum.PDF;

  isFormValid = false;

  enumToArray = enumToArray;
  cashiersReportExportTypeEnum = CashiersReportExportTypeEnum;

  exporting = false;
  async exportCashiersReport() {
    const timeFromSplit = this.timeFrom.split(":");
    const timeToSplit = this.timeTo.split(":");

    const dateTimeFrom = new Date(this.dateRange[0]);
    const dateTimeTo = new Date(this.dateRange[1]);

    dateTimeFrom.setHours(+timeFromSplit[0], +timeFromSplit[1]);
    dateTimeTo.setHours(+timeToSplit[0], +timeToSplit[1]);

    const request = {
      cashRegisterId: this.cashRegisterId,
      // need to do this as we want to preserve users's time and date selection, Vue otherwise turns dates into UTC time before sending the request
      // which loses user's selection because 23:59 UTC+2 is received on the server as 21:59 UTC+0 and the have no way of knowing if user actually
      // selected 21:59, 23:59, or something else
      dateTimeFrom: getDateTimeOffsetString(dateTimeFrom),
      dateTimeTo: getDateTimeOffsetString(dateTimeTo),
      exportType: this.exportType,
      cultureCode: this.internalLanguage,
    };

    this.exporting = true;
    await this.$http
      .get("/financialDocuments/export/ExportCashiersReport", {
        params: request,
        responseType: "blob",
      })
      .then((res) => {
        const groups = /filename=(?<filename>[^;]+);/.exec(
          res.headers["content-disposition"]
        )?.groups;

        saveFile(res.data, groups?.filename ?? `CashiersReport.pdf`);
      })
      .finally(() => {
        this.exporting = false;
      });
  }

  get rules() {
    return {
      required: (value: any) => !!value || this.$t("Validation.Required"),
      required0Allowed: (value: any) =>
        !!value || value === 0 || this.$t("Validation.Required"),
      requiredDateRange: (value: string[]) =>
        value.length === 2 || this.$t("Validation.RequiredDateRange"),
    };
  }

  get sortedCashRegistries() {
    return (
      this.allCashRegisters?.sort((a, b) => (a.name > b.name ? 1 : -1)) ?? []
    );
  }

  @Watch("internalOpen")
  openWatch(fresh: boolean) {
    if (fresh) {
      this.dateRange = [
        new Date().toISOString().substring(0, 10),
        new Date().toISOString().substring(0, 10),
      ];
      this.timeFrom = "00:00";
      this.timeTo = "23:59";
      this.cashRegisterId = this.activeCashRegister?.id ?? null;
      this.exportType = CashiersReportExportTypeEnum.PDF;
    }
  }

  @Getter("cashRegister/allCashRegisters")
  allCashRegisters?: CashRegisterModel[];

  @Getter("cashRegister/activeCashRegister")
  activeCashRegister?: CashRegisterModel;

  @Getter("language/language") language?: string;
  get internalLanguage() {
    return this.language ?? "hr-HR";
  }
}
